import styled from '@emotion/styled';

import { colors } from 'src/styles/colors';
import { ZeeFontMedium, ZeeFontRegular } from 'src/styles/font';
import { MediaBP } from 'src/styles/mediaQuery';
import { flex } from 'src/styles/utils';

export const Container = styled.div`
  width: fit-content;
  ${flex('column', 'start', 'start')};
`;

export const Icon = styled.img`
  height: 24px;
  ${MediaBP.MediaXl} {
    height: 36px;
  } ;
`;

export const SubTitle = styled.div`
  ${ZeeFontMedium(10, 16)};
  ${MediaBP.MediaSm} {
    ${ZeeFontMedium(14, 20)};
  }
  ${MediaBP.MediaLg} {
    ${ZeeFontMedium(16, 24)};
  } ;
`;

export const Title = styled.div`
  margin-top: 12px;
  color: ${colors.FeatureGrey};
  ${ZeeFontRegular(9, 14)};
  ${MediaBP.MediaSm} {
    ${ZeeFontRegular(11, 18)};
  }
  ${MediaBP.MediaLg} {
    ${ZeeFontRegular(16, 24)};
  } ;
`;
